module.exports = __webpack_public_path__ + "70fddd679c427556da7e4b71cbaff130.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/arrows-menu.jpg
// module id = Orl+
// module chunks = 0